import { Component, ojs, app } from "modular-openscriptjs";
import { either } from "../../../helpers";

const h = app("h");
const router = app("router");

export default class TopCategoryView extends Component {
	render(category, ...args) {
		return h.div(
			{
				class: "category-card position-relative overflow-hidden rounded-4 border bg-light shadow-sm w-100",
				style: "aspect-ratio: 1/1;",
				role: "button",
				onclick: h.func("route.to", "category.products", { categoryId: category.id }),
			},
			// Background Image or Fallback
			either(
				category.image,
				h.img({
					src: category.image,
					class: "position-absolute top-0 start-0 w-100 h-100 object-fit-cover transition-transform duration-700 hover-scale-110",
					alt: category.name,
				}),
				h.div(
					{
						class: "position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center overflow-hidden",
						style: "background-color: #973e87;", // Solid Brand Purple
					},
					// Abstract Shapes
					h.div({
						class: "position-absolute rounded-circle",
						style: "width: 80%; padding-bottom: 80%; top: -30%; right: -30%; background-color: #fed27d; opacity: 0.15;", // Brand Gold
					}),
					h.div({
						class: "position-absolute rounded-circle",
						style: "width: 50%; padding-bottom: 50%; bottom: -10%; left: -10%; background-color: #fed27d; opacity: 0.1;", // Brand Gold
					}),
					h.span(
						{
							class: "display-1 fw-bold text-white opacity-25 select-none position-absolute",
							style: "transform: rotate(-15deg) scale(1.5);",
						},
						category.name
							? category.name.charAt(0).toUpperCase()
							: ""
					)
				)
			),
			// Bottom Overlay
			h.div(
				{
					class: "position-absolute bottom-0 start-0 w-100 p-3",
				},
				h.div(
					{
						class: "category-name-overlay d-inline-flex align-items-center justify-content-between p-2 px-3 rounded-pill text-dark shadow-sm border border-white border-opacity-50",
						style: "background: rgba(255, 255, 255, 0.75); backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px);",
					},
					h.span(
						{
							class: "fw-bold text-truncate fs-xsm pe-1 d-flex align-items-center text-wrap",
						},
						category.name
					)
				)
			),
			...args
		);
	}
}

ojs(TopCategoryView);
